import styled from 'styled-components';
import vector from './assets/vector.png';
import phone from './assets/phone.png';
import graduate from './assets/graduate.jpg';

export const AppWrapper = styled('div')`
  /* width: 100%; */
  overflow-x: hidden !important;
  @media only screen and (min-width: 600px) {
    /* background-image: ${() =>
      `url(${'https://i.pinimg.com/originals/82/b8/25/82b8254b0f7e2160d9d70170a770031a.jpg'})`}; */
background: #152b54;
::before {
content: "";
background-image: url(${graduate});
background-size: cover;
position: absolute;
top: 0px;
right: 0px;
bottom: 0px;
left: 0px;
opacity: 0.1;
background-size: 100% 100%;
}
min-height: 100vh;
}
@media only screen and (max-width: 600px) {
  background: #152b54;
    /* background-image: ${() =>
      `url(${'https://i.pinimg.com/originals/82/b8/25/82b8254b0f7e2160d9d70170a770031a.jpg'})`}; */
    background-size: 1000px 100%;
    min-height: 100vh;
  }
  /* display: flex; */
  justify-content: center;
  position: relative;
`;

export const Footer = styled('div')`
  position: absolute;
  background: #152b54;
  z-index: 999999999;
  bottom: 0;
  height: 40px;
  width: 100%;
  padding-top: 10px;
  border-top: 1px solid rgb(191, 191, 191, 0.2);
`;
